import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isDefined } from '../../../../../utils';
import BarChart from '../../../Chart/components/BarChart';

//const teams = [
//    { id: 0, name: 'All Teams', values: [ { name: "RES", value: 70 }, { name: "CSAT", value: 61 }, { name: "JibeSession", value: 840 }] },
//    { id: 0, name: 'Team 1', values: [{ name: "ASAT", value: 65 }, { name: "RES", value: 69 }, { name: "CSAT", value: 67 }, { name: "JibeSession", value: 740 }] },
//    { id: 0, name: 'Team 2', values: [{ name: "ASAT", value: 72 }, { name: "RES", value: 77 }, { name: "CSAT", value: 72 }, { name: "JibeSession", value: 780 }] },
//];

class BarChartTeamCompareContainer extends Component {
    constructor(props) {
        super(props);
    }

    //componentDidMount() {

    //}

    render() {
        const
            {
                teamsJibedPercentageStats,
                selectedTeams,
                calibratedOnSurveyQuestions
            } = this.props;

        if (!isDefined(teamsJibedPercentageStats) || !isDefined(calibratedOnSurveyQuestions)) {
            return <div></div>
        }

        const filteredteamsJibedPercentageStats = (selectedTeams && teamsJibedPercentageStats)
            ? teamsJibedPercentageStats.filter(t => (selectedTeams.some(st => st.id == t.teamId))
                || t.name === "All Teams")
            : teamsJibedPercentageStats;

        const teamsForBarChart = filteredteamsJibedPercentageStats ? filteredteamsJibedPercentageStats.map(t => {
            let res = {
                id: 0,
                name: t.name,
                values: [
                    { name: "ASAT", value: t.agentCount > 0 ? parseInt((100 * t.representativeSatisfaction / t.agentCount)) : undefined },
                    { name: "RES", value: t.agentCount > 0 ? parseInt((100 * t.resolution / t.agentCount)) : undefined },
                    //{ name: "CSAT", value: t.agentCount > 0 ? parseInt((100 * t.customerSatisfaction / t.agentCount)) : undefined },
                    //{ name: "JibeSession", value: t.agentCount > 0 ? parseInt((100 * t.jibeSessionsPast30DaysCount / t.agentCount)) : undefined },
                    /*{ name: "JibeSession", value: t.jibeSessionsPast30DaysCount }*/
                ]
            };
            return res;
        })
            : undefined;

        return <div>
            <BarChart teams={teamsForBarChart} loading={false} changePeriod={this.changePeriod} />
        </div>
    }
}

const select = state => ({});

export default connect(select)(BarChartTeamCompareContainer);